import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { PurchaseOrderTypeService } from '../proxy/controlling/controllers/purchase-order-type.service';
import { CompanyCodeService } from '../proxy/controlling/controllers/company-code.service';
import { CurrencyService } from '../proxy/controlling/controllers/currency.service';
import { PurchaseOrderDetail } from '@controlling/purchase-order-detail/purchase-order-detail';
import { VendorService } from '@controlling/proxy/controlling/controllers/vendor.service';

FieldBuilder.setNamespace('Controlling');

export const PURCHASEORDER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('number', 'Entity.PurchaseOrder.Number')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('purchasingOrganization', 'Entity.PurchaseOrder.PurchasingOrganization')
    .maxLength(35)
    .build(),
  FieldBuilder
    .text('purchasingGroup', 'Entity.PurchaseOrder.PurchasingGroup')
    .maxLength(35)
    .build(),
  FieldBuilder
    .date('purchaseDate', 'Entity.PurchaseOrder.PurchaseDate')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('purchaseOrderTypeId', 'Entity.PurchaseOrderType', PurchaseOrderTypeService)
    .required()
    .displayFromNested('purchaseOrderType.name')
    .sortBy('purchaseOrderType.name')
    .build(),
  FieldBuilder
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .build(),
  FieldBuilder
    .foreignKey('companyCodeId', 'Entity.CompanyCode', CompanyCodeService)
    .required()
    .displayFromNested('companyCode.name')
    .sortBy('companyCode.name')
    .build(),
  FieldBuilder
    .foreignKey('currencyId', 'Entity.Currency', CurrencyService)
    .required()
    .displayFromNested('currency.name')
    .sortBy('currency.name')
    .build(),
];

export const PURCHASEORDER_CONFIG = {
  entityName: 'PurchaseOrder',
  localizationKey: 'Controlling::Entity.PurchaseOrder',
  fields: PURCHASEORDER_FIELDS,
  permission: 'ControllingSap.PurchaseOrders',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
  getChildren: (_row: any, allChildren: any[]) => {
    return allChildren;
  },
  children: [
    {
      entityName: 'PurchaseOrderDetail',
      foreignKeyField: 'purchaseOrderId',
      localizationKey: 'Controlling::Entity.PurchaseOrderDetail',
      component: PurchaseOrderDetail,
    }
  ],
};
